import classNames from "classnames";
import noop from "lodash/noop";
import React, { FunctionComponent, MouseEvent, ReactNode } from "react";
import "./style.scss";

export type ButtonSize = "big-round" | "normal" | "round";

export type ButtonType =
  | "accent"
  | "accent-inverted"
  | "error"
  | "error-inverted"
  | "error-lightest"
  | "foggy"
  | "neutral"
  | "neutral-inverted"
  | "primary"
  | "primary-darker"
  | "primary-darker-transparent"
  | "primary-inverted"
  | "primary-lightest"
  | "validation"
  | "validation-inverted"
  | "warning"
  | "warning-inverted";

interface Props {
  children: ReactNode;
  disabled?: boolean;
  onClick?: (event: MouseEvent) => void;
  size?: ButtonSize;
  title?: string;
  type?: ButtonType;
}

const Button: FunctionComponent<Props> = ({
  children,
  disabled = false,
  onClick = noop,
  size = "normal",
  title,
  type = "primary",
}) => {
  return (
    <button
      className={classNames("Button", {
        "Button--size-bigRound": size === "big-round",
        "Button--size-normal": size === "normal",
        "Button--size-round": size === "round",

        "Button--type-accent": type === "accent",
        "Button--type-accentInverted": type === "accent-inverted",
        "Button--type-error": type === "error",
        "Button--type-errorInverted": type === "error-inverted",
        "Button--type-errorLightest": type === "error-lightest",
        "Button--type-foggy": type === "foggy",
        "Button--type-neutral": type === "neutral",
        "Button--type-neutralInverted": type === "neutral-inverted",
        "Button--type-primary": type === "primary",
        "Button--type-primaryDarker": type === "primary-darker",
        "Button--type-primaryDarkerTransparent": type === "primary-darker-transparent",
        "Button--type-primaryInverted": type === "primary-inverted",
        "Button--type-primaryLightest": type === "primary-lightest",
        "Button--type-validation": type === "validation",
        "Button--type-validationInverted": type === "validation-inverted",
        "Button--type-warning": type === "warning",
        "Button--type-warningInverted": type === "warning-inverted",
      })}
      disabled={disabled}
      onClick={disabled ? noop : onClick}
      title={title}
    >
      {children}
    </button>
  );
};

export default Button;
